import { z } from 'zod';

export const omnitagSearchTagsResponseZod = z.record(z.string(), z.string());
export type OmnitagSearchTagsResp = z.infer<
  typeof omnitagSearchTagsResponseZod
>;
